export default "__VITE_ASSET__aTaGQlyh__"